import { render } from "./BannersComponent.vue?vue&type=template&id=3c2b8f26&scoped=true&ts=true"
import script from "./BannersComponent.vue?vue&type=script&lang=ts"
export * from "./BannersComponent.vue?vue&type=script&lang=ts"

import "./BannersComponent.vue?vue&type=style&index=0&id=3c2b8f26&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2b8f26"]])

export default __exports__